(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeContact(root = document) {
      root.querySelectorAll('.nutripeak-klaviyo-contact').forEach((form) => {
        if (form.dataset.consentInitialized) return;
        form.dataset.consentInitialized = 'true';
        const button = form.querySelector('button[type="submit"]');
        const consent = form.querySelector('[name="contact[Consent]"]');
        const settings = form.querySelector('.nutripeak-contact-consent');
        const status = form.querySelector('.nutripeak-contact-status');
        let saved = false;
        let pending = false;
        let submissionId;
        button.disabled = false;
        form.addEventListener('input', () => { saved = false; submissionId = undefined; });
        form.addEventListener('submit', async (event) => {
          if (saved && consent.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (pending || !form.reportValidity() || !consent.checked) return;
          pending = true;
          button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          status.textContent = '';
          submissionId = submissionId || crypto.randomUUID();
          const timestamp = new Date().toISOString();
          const source = window.location.origin + window.location.pathname;
          const wording = form.querySelector('[data-contact-wording]').textContent.trim();
          const email = form.querySelector('input[type="email"]').value.trim();
          const name = form.querySelector('input[autocomplete="name"]').value.trim();
          const message = form.querySelector('textarea').value.trim();
          const payload = { data: { type: 'event', attributes: {
            unique_id: submissionId,
            time: timestamp,
            metric: { data: { type: 'metric', attributes: { name: 'Nutripeak Contact Enquiry' } } },
            profile: { data: { type: 'profile', attributes: { email } } },
            properties: { Name: name, Email: email, Message: message, Consent: true,
              ConsentWording: wording, ConsentVersion: '2026-09-30-contact-v1',
              ConsentTimestamp: timestamp, Source: source, Language: settings.dataset.language,
              Form: 'nutripeak-contact-v1', SubmissionId: submissionId }
          } } };
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 30000);
          try {
            const response = await fetch('https://a.klaviyo.com/client/events?company_id=VTHYpV', {
              method: 'POST',
              headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
              body: JSON.stringify(payload), signal: controller.signal
            });
            if (!response.ok) throw new Error('Contact consent could not be saved');
            // A changed form must acquire its own consent record before delivery.
            if (email !== form.querySelector('input[type="email"]').value.trim() ||
                name !== form.querySelector('input[autocomplete="name"]').value.trim() ||
                message !== form.querySelector('textarea').value.trim() || !consent.checked) {
              status.textContent = settings.dataset.error;
              return;
            }
            form.elements['contact[Consent timestamp]'].value = timestamp;
            form.elements['contact[Consent source]'].value = source;
            form.elements['contact[Enquiry ID]'].value = submissionId;
            saved = true;
            button.disabled = false;
            // Retain Shopify's direct contact delivery and spam challenge.
            form.requestSubmit(button);
          } catch (error) {
            status.textContent = settings.dataset.error;
          } finally {
            window.clearTimeout(timeout);
            pending = false;
            button.disabled = false;
            form.removeAttribute('aria-busy');
          }
        }, true);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeContact());
    else initializeContact();
    document.addEventListener('shopify:section:load', (event) => initializeContact(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const consentVersion = '2026-09-30-v2';
    const consentForm = 'nutripeak-footer-v1';
    function initializeNewsletter(root = document) {
      root.querySelectorAll('[data-nutripeak-newsletter]').forEach((form) => {
        if (form.dataset.initialized) return;
        form.dataset.initialized = 'true';
        const email = form.elements.email;
        const consent = form.elements.newsletter_consent;
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('.nutripeak-newsletter-status');
        consent.addEventListener('invalid', () => consent.setCustomValidity(form.dataset.consentError));
        consent.addEventListener('change', () => consent.setCustomValidity(''));
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (!form.reportValidity() || !consent.checked || button.disabled) return;
          button.disabled = true;
          form.setAttribute('aria-busy', 'true');
          status.textContent = '';
          const timestamp = new Date().toISOString();
          const source = window.location.origin + window.location.pathname;
          const wording = form.querySelector('[data-consent-wording]').textContent.trim();
          const payload = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Nutripeak footer newsletter; consent version ' + consentVersion + '; ' + form.dataset.language,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email.value.trim(),
                      properties: {
                        '$source': 'Nutripeak footer newsletter',
                        'Newsletter consent': true,
                        'Newsletter consent wording': wording,
                        'Newsletter consent wording version': consentVersion,
                        'Newsletter consent timestamp': timestamp,
                        'Newsletter consent source': source,
                        'Newsletter consent language': form.dataset.language,
                        'Newsletter consent form': consentForm
                      },
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    },
                    meta: { patch_properties: { append: { 'Newsletter consent history': JSON.stringify({ timestamp, wording, version: consentVersion, source, language: form.dataset.language, form: consentForm }) } } }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: 'WnhZed' } } }
            }
          };
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 30000);
          try {
            const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=VTHYpV', {
              method: 'POST',
              headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
              body: JSON.stringify(payload),
              signal: controller.signal
            });
            if (!response.ok) throw new Error('Newsletter signup failed');
            try {
              const published = window.Shopify?.analytics?.publish('nutripeak_newsletter_signup_accepted', { source: consentForm });
              if (published?.catch) published.catch(() => {});
            } catch (_) {}
            status.textContent = form.dataset.success;
            form.reset();
            consent.setCustomValidity('');
          } catch (error) {
            status.textContent = form.dataset.error;
          } finally {
            window.clearTimeout(timeout);
            button.disabled = false;
            form.removeAttribute('aria-busy');
          }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeNewsletter());
    else initializeNewsletter();
    document.addEventListener('shopify:section:load', (event) => initializeNewsletter(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function initializeNutripeakArticles() {
  document.querySelectorAll('.np-article').forEach(article => {

    const body = article.querySelector('.np-article__body');
    if (!body.dataset.articleEnhancements) {
      const originalChildren = Array.from(body.children).filter(child => child.textContent.trim() || child.querySelector('img'));
      const introParagraphs = originalChildren.filter(child => child.tagName === 'P');
      const productTemplate = article.querySelector('.np-article__product-template');
      const supportTemplate = article.querySelector('.np-article__support-template');
      if (productTemplate) {
        const anchor = introParagraphs[Math.min(1, introParagraphs.length - 1)] || originalChildren[0];
        if (anchor) anchor.after(productTemplate.content.cloneNode(true));
        else body.append(productTemplate.content.cloneNode(true));
      }
      if (supportTemplate) {
        let index = Math.floor(originalChildren.length / 2);
        while (index > 0 && /^H[1-6]$/.test(originalChildren[index].tagName)) index--;
        const anchor = originalChildren[index];
        if (anchor) anchor.after(supportTemplate.content.cloneNode(true));
        else body.append(supportTemplate.content.cloneNode(true));
      }
      body.dataset.articleEnhancements = 'true';
    }
    const contents = article.querySelector('.np-article__contents');
    const list = contents.querySelector('ul');
    if (list.children.length) return;
    const headings = article.querySelectorAll('.np-article__body h2:not(.np-article__product-title), .np-article__body h3');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `${article.id}-heading-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
    });
    contents.hidden = headings.length === 0;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeNutripeakArticles);
else initializeNutripeakArticles();
document.addEventListener('shopify:section:load', initializeNutripeakArticles);

  } catch(e) { console.error(e); }
})();
})();
